export const renderPrice = price => {
  return `$${price.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}`;
};

export const renderPriceWithoutCents = price => {
  let priceStr = price % 1 === 0 ? price.toString() : price.toFixed(2);
  return `$${priceStr.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}`;
};
